export const initialValues = {
  title: '',
  description: '',
  preview: '',
  difficulty: '',
  free: false,
  scheduledDay: '',
};
